import { create } from "zustand";
import type { BusinessCard } from "./types";
import type { DetectedSheet } from "./sheets";

// シート + 名刺一覧の状態管理。
// 認証(useAuthStore)とは別ストア、責務分離。
// Phase 1 ではローカルメモリのみ(永続化不要、再ログイン時に再取得)

type LoadStatus = "idle" | "loading" | "ready" | "no_sheet" | "error";

interface CardsState {
  status: LoadStatus;
  sheet: DetectedSheet | null;
  cards: BusinessCard[];
  error: string | null;

  setStatus: (status: LoadStatus) => void;
  setSheet: (sheet: DetectedSheet | null) => void;
  setCards: (cards: BusinessCard[]) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useCardsStore = create<CardsState>((set) => ({
  status: "idle",
  sheet: null,
  cards: [],
  error: null,

  setStatus: (status) => set({ status }),
  setSheet: (sheet) => set({ sheet }),
  setCards: (cards) => set({ cards }),
  setError: (error) => set({ error }),

  reset: () =>
    set({
      status: "idle",
      sheet: null,
      cards: [],
      error: null,
    }),
}));
